import React from "react";
import type { RouteObject } from "react-router";
import RootLayout from "./components/RootLayout";
import RequireAuth from "../auth/components/RequireAuth";
import IndexRedirect from "../auth/components/IndexRedirect";
import { dataEnteringRoutes } from "../dataEntering";
import { supervisingRoutes } from "../supervising";
import { managementRoutes } from "../management";
import Login from "../auth/routes/Login";
import NotFound from "../../shared/components/NotFound";
import { RouteErrorElement } from "../../shared/components/ChunkErrorBoundary";

export const routes: RouteObject[] = [
    {
        element: <RootLayout />,
        errorElement: <RouteErrorElement />,
        children: [
            { index: true, element: <IndexRedirect /> },
            { path: "login", element: <Login /> },
            {
                element: <RequireAuth />,
                children: [
                    { path: "data-entering", children: dataEnteringRoutes },
                    { path: "management", children: managementRoutes },
                    { path: "supervising", children: supervisingRoutes },
                ],
            },
            { path: "*", element: <NotFound /> },
        ],
    },
];
